export default __webpack_public_path__ + "static/media/p10.ce985a87.jpg";